module.exports = __webpack_public_path__ + "img/presell.f8f61c0e.svg";